import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthStoreService } from './auth-store.service';

export const authGuard: CanActivateFn = () => {
  const authStore = inject(AuthStoreService);
  const router = inject(Router);

  if (authStore.isAuthenticated()) {
    return true;
  }

  return router.createUrlTree(['/']);
};

export const adminGuard: CanActivateFn = () => {
  const authStore = inject(AuthStoreService);
  const router = inject(Router);

  if (!authStore.isAuthenticated()) {
    return router.createUrlTree(['/']);
  }

  if (authStore.isPlatformUser()) {
    return true;
  }

  authStore.clearSession();
  return router.createUrlTree(['/'], {
    queryParams: { reason: 'admin-required' },
  });
};

export const loggedOutGuard: CanActivateFn = () => {
  const authStore = inject(AuthStoreService);
  const router = inject(Router);

  if (authStore.isAuthenticated() && authStore.isPlatformUser()) {
    return router.createUrlTree(['/dashboard']);
  }

  return true;
};
